import { select, useSelect, useDispatch } from '@wordpress/data';
import { getSetting } from '@woocommerce/settings';
const store = select( 'wc/store/cart' );
import { __ } from '@wordpress/i18n';
const settings = getSetting( 'address-autocomplete-shipping_data');
var gacMapOptions;
var gacshippingmap;
var shipping_dragged = false;
var gacshippingmarker;
var oldshippingMarker;
function setShippingFields( place ) {
	if ( 'yes' == gac_google_address.enable_mapping ) {
		var address_1 = gac_google_address.address_1;
		var address_2 = gac_google_address.address_2;
		var city = gac_google_address.city_mapping;
		var state = gac_google_address.state_mapping;
		var postcode = gac_google_address.postcode_mapping;
	} else {
		var address_1 = '';
		var address_2 = '';
		var city = '';
		var state = '';
		var postcode = '';
	}
	var country = '';
	var postal_town = '';
	var sublocality_city = '';
	for ( var i = 0; i < place.address_components.length; i++ ) {
		if ( 'yes' == gac_google_address.enable_mapping ) {
			if ( place.address_components[i].types.includes('street_number') ) {
				address_1 = address_1.replace('{street_number}', place.address_components[i].long_name+ ' ');
				address_2 = address_2.replace('{street_number}', place.address_components[i].long_name+ ' ');
			} else if ( place.address_components[i].types.includes('route') ) {
				address_1 = address_1.replace('{route}', place.address_components[i].long_name);
				address_2 = address_2.replace('{route}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('plus_code') ) {
				address_1 = address_1.replace('{plus_code}', place.address_components[i].long_name+ ' ');
				address_2 = address_2.replace('{plus_code}', place.address_components[i].long_name+ ' ');
			} else if ( place.address_components[i].types.includes('subpremise') ) {
				address_1 = address_1.replace('{subpremise}', place.address_components[i].long_name+ ' ');
				address_2 = address_2.replace('{subpremise}', place.address_components[i].long_name+ ' ');
			} else if ( place.address_components[i].types.includes('neighborhood') ) {
				address_1 = address_1.replace('{neighborhood}', place.address_components[i].long_name);
				address_2 = address_2.replace('{neighborhood}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('sublocality_level_2') ) {
				address_1 = address_1.replace('{sublocality_level_2}', place.address_components[i].long_name);
				address_2 = address_2.replace('{sublocality_level_2}', place.address_components[i].long_name);
				city = city.replace('{sublocality_level_2}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('sublocality_level_1') ) {
				address_1 = address_1.replace('{sublocality_level_1}', place.address_components[i].long_name);
				address_2 = address_2.replace('{sublocality_level_1}', place.address_components[i].long_name);
				city = city.replace('{sublocality_level_1}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('sublocality') ) {
				address_1 = address_1.replace('{sublocality}', place.address_components[i].long_name);
				address_2 = address_2.replace('{sublocality}', place.address_components[i].long_name);
				city = city.replace('{sublocality}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('locality') ) {
				city = city.replace('{locality}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('postal_town') ) {
				city = city.replace('{postal_town}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('administrative_area_level_3') ) {
				state = state.replace('{administrative_area_level_3}', place.address_components[i].short_name);
			} else if ( place.address_components[i].types.includes('administrative_area_level_2') ) {
				state = state.replace('{administrative_area_level_2}', place.address_components[i].short_name);
			} else if ( place.address_components[i].types.includes('administrative_area_level_1') ) {
				state = state.replace('{administrative_area_level_1}', place.address_components[i].short_name);
			} else if ( place.address_components[i].types.includes('country') ) {
				country = place.address_components[i].short_name;
			} else if ( place.address_components[i].types.includes('postal_code_suffix') ) {
				postcode = postcode.replace('{postal_code_suffix}', place.address_components[i].long_name);
			} else if ( place.address_components[i].types.includes('postal_code') ) {
				postcode = postcode.replace('{postal_code}', place.address_components[i].long_name);
			}
		} else {
			if ( place.address_components[i].types.includes('street_number') ) {
				address_1 = address_1 + ' ' + place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('plus_code') ) {
				address_1 = address_1 + ' ' + place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('subpremise') ) {
				address_1 = address_1 + ' ' + place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('route') ) {
				address_2 = address_2 + ' ' + place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('neighborhood') ) {
				address_2 = address_2 + ' ' + place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('sublocality_level_1') ) {
				sublocality_city = place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('locality') ) {
				city = place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('postal_town') ) {
				postal_town = place.address_components[i].long_name;
				city = place.address_components[i].long_name;
			} else if ( place.address_components[i].types.includes('administrative_area_level_1') ) {
				state = place.address_components[i].short_name;
			} else if ( place.address_components[i].types.includes('country') ) {
				country = place.address_components[i].short_name;
			} else if ( place.address_components[i].types.includes('postal_code') ) {
				postcode = place.address_components[i].long_name;
			}
		}
	}
	var placeName = place.name ? place.name : '';
	address_1 = address_1.replace('{name}', placeName);
	address_1 = address_1.replace('{plus_code}', '').replace('{neighborhood}', '').replace('{street_number}', '').replace('{route}', '').replace('{sublocality_level_2}', '').replace('{sublocality_level_1}', '').replace('{sublocality}', '').replace('{subpremise}', '');
	address_2 = address_2.replace('{name}', placeName);
	address_2 = address_2.replace('{plus_code}', '').replace('{neighborhood}', '').replace('{street_number}', '').replace('{route}', '').replace('{sublocality_level_2}', '').replace('{sublocality_level_1}', '').replace('{sublocality}', '').replace('{subpremise}', '');
	city = city.replace('{sublocality_level_2}', '').replace('{sublocality_level_1}', '').replace('{sublocality}', '').replace('{locality}', '');
	state = state.replace('{administrative_area_level_3}', '').replace('{administrative_area_level_2}', '').replace('{administrative_area_level_1}', '');
	postcode = postcode.replace('{postal_code_suffix}', '').replace('{postal_code}', '');
	if ( 'GB' == country || 'SE' == country ) {
		city = postal_town ? postal_town : city;
	}
	if ( 'NY' == state ) {
		city = sublocality_city ? sublocality_city : city;
	}
	address_1 = address_1.replace('  ', ' ');
	address_2 = address_2.replace('  ', ' ');
	return {address_1: address_1, address_2: address_2, city: city, state:state,
		country: country, postcode:postcode};
}
const Map = () => {
	const { setShippingAddress } = useDispatch( 'wc/store/cart' );
	function geocodeShippingPosition( pos, gacgeocoder ) {
		gacgeocoder.geocode({
		latLng: pos
		}, function( responses, status ) {
			if ( responses && responses.length > 0 ) {
				if ( jQuery('#gac_auto_complete_shipping_address').length > 0 ) {
					jQuery('#gac_auto_complete_shipping_address').val(responses[1].formatted_address);
				}
				console.log(responses)
				// if ( customerData.shippingAddress.address_1.length > 0 ) {
					var address = setShippingFields( responses[1] );
					console.log(address);
					setShippingAddress(address);
				// }
				shipping_dragged = true;
			}
		});
	}
	function gac_autocomplete_addresspicker() {
		if ( jQuery(document).find('#gac_autocomplete_shipping_block_map').length > 0 ) {
			var customerData = store.getCustomerData();
			var address_1 = customerData.shippingAddress.address_1;
			var address_2 = customerData.shippingAddress.address_2;
			var state = customerData.shippingAddress.state;
			var city = customerData.shippingAddress.city;
			var country = customerData.shippingAddress.country;
			var postcode = customerData.shippingAddress.postcode;
			//display default address on map
			setTimeout(function() {
			// if ( country != initCountry ) {
			// 	var addressString = country;
			// } else {
				// if(g.currentMarkers && g.currentMarkers.length !== 0){            
				// 	$.each(g.currentMarkers, function(i,item){
				// 		item.setMap(null);
				// 	});
				// }
				var addressString = address_1;
				addressString = (address_2) ? (addressString+" "+ address_2) : addressString;
				addressString = (city) ? (addressString+", "+ city) : addressString;
				addressString = (state) ? (addressString+" "+ state) : addressString;
				addressString = (country) ? (addressString+" "+ country) : addressString;
				addressString = (postcode) ? (addressString+" "+ postcode) : addressString;
			// }
				if ( !shipping_dragged ) {
					var gacaddress = (addressString) ? addressString : gac_google_address.default;
					var gacgeocoder = new google.maps.Geocoder();
					gacgeocoder.geocode({'address': gacaddress}, function ( results, status ) {
						if ( status == google.maps.GeocoderStatus.OK ) {
							var currentshippingLatLng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
							var icon = gac_google_address.map_icon ? gac_google_address.map_icon : '';
							if ( '' !== icon ) {
								icon = {
									url: icon,
									scaledSize: new google.maps.Size(30, 30),
								};
							}
							gacshippingmarker = new google.maps.Marker({
								position: currentshippingLatLng,
								draggable: ( gac_google_address.enable_shipping_drag == 'yes' ) ? true : false,
								animation: google.maps.Animation.DROP,
								map: gacshippingmap,
								icon: icon
							});
							google.maps.event.addListener(gacshippingmarker, 'dragend', function() {
								geocodeShippingPosition(gacshippingmarker.getPosition(), gacgeocoder);
								shipping_dragged = true;
							});
							if ( oldshippingMarker ) {
								oldshippingMarker.setMap(null);
							}
							oldshippingMarker = gacshippingmarker;
							gacshippingmap.setCenter(currentshippingLatLng);
						}
					});
				}
			}, 2000);
		}
	}
	jQuery(window).on('load', function() {
		if ( jQuery('.wp-block-shipping-autocomplete-field').length > 0 ) {
			jQuery('.wp-block-shipping-autocomplete-field').insertAfter(jQuery('#shipping').find('div.wc-block-components-address-form__last_name'));
		}
		var style = gac_google_address.map_style ? jQuery.parseJSON(gac_google_address.map_style) : '';
		gacMapOptions = {
			scrollwheel: true,
			zoom: parseInt(gac_google_address.zoom),
			// center: { lat: 23.634501, lng: -102.552788 },
			styles : style
		};
		gacshippingmap = new google.maps.Map(document.getElementById('gac_autocomplete_shipping_block_map'), gacMapOptions);
	});
	gac_autocomplete_addresspicker();
	return ('yes' == gac_google_address.showmap) ? <div className="gac_autocomplete_shipping_block_map" id="gac_autocomplete_shipping_block_map"></div> : '';
}
export const Block = ( { checkoutExtensionData, extensions } ) => {
	const { setShippingAddress } = useDispatch( 'wc/store/cart' );
	const AutocompletePlaces = () => {
		if ( 'yes' == gac_google_address.nofield ) {
			var shipping = document.getElementById('shipping-address_1');
		} else {
			var shipping = document.getElementById('gac_auto_complete_shipping_address');
		}
		const options = {
			fields: ["address_components", "geometry", "icon", "name"],
			strictBounds: true,
		};
		var restrict_countries = JSON.parse(gac_google_address.allowed_countries);
		var shipping_address = new google.maps.places.Autocomplete(shipping, options);
		if ( restrict_countries.length > 0 ) {
			shipping_address.setComponentRestrictions(
				{'country': restrict_countries});
		}
		google.maps.event.addListener(shipping_address, 'place_changed', function () {
			var place = shipping_address.getPlace();
			var address = setShippingFields( place );
			setShippingAddress(address);
		});
    }
	if ( 'yes' == gac_google_address.nofield ) {
		jQuery(document).on('input', '#shipping-address_1', function() {
			AutocompletePlaces();
		});
	}
	const fieldLabel = ('' != settings.autocomplete_field_label && '' == gac_google_address.nofield ) ? <label for="gac_auto_complete_shipping_address">{settings.autocomplete_field_label}</label> : '';
	return (
		<div className="wp-block-shipping-autocomplete-field">
			{fieldLabel}
			{('yes' == gac_google_address.nofield) ? '' :
			<input type="text" id="gac_auto_complete_shipping_address" onChange={AutocompletePlaces} />}
			<Map />
		</div>
	);
};